<template>
  <canvas :id="id" class="chart-canvas" :height="height"></canvas>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "MixedChart",
  props: {
    id: {
      type: String,
      default: "mixed-chart",
    },
    height: {
      type: [String, Number],
      default: "260",
    },
    chart: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    const ctx = document.getElementById(this.id).getContext("2d");

    let chartStatus = Chart.getChart(this.id);
    if (chartStatus) {
      chartStatus.destroy();
    }

    new Chart(ctx, {
      type: "bar",
      data: {
        labels: this.chart.labels,
        datasets: this.chart.datasets.map((d, i) => ({
          label: d.label,
          data: d.data,
          backgroundColor: ["#38bdf8", "#ec4899", "#10b981"][i % 3],
          borderRadius: 6,
          borderSkipped: false,
          maxBarThickness: 14,
        })),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "top",
            align: "end",
            labels: {
              boxWidth: 10,
              boxHeight: 10,
              usePointStyle: true,
              pointStyle: "circle",
              color: "#94a3b8",
              font: {
                size: 11,
                weight: "600",
              },
            },
          },
          tooltip: {
            backgroundColor: "#1e293b",
            titleColor: "#f8fafc",
            bodyColor: "#cbd5e1",
            borderColor: "rgba(255,255,255,0.1)",
            borderWidth: 1,
            padding: 10,
            cornerRadius: 8,
          },
        },
        scales: {
          y: {
            grid: {
              color: "rgba(255, 255, 255, 0.05)",
              drawBorder: false,
              borderDash: [4, 4],
            },
            ticks: {
              color: "#64748b",
              font: { size: 11 },
            },
          },
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              color: "#64748b",
              font: { size: 11 },
            },
          },
        },
      },
    });
  },
};
</script>
